import * as React from "react";
import { type IColumn } from "@fluentui/react";
import { makeObservable, computed } from "mobx";
import { observer } from "mobx-react";
import { type UUID } from "../../utils/uuid";
import { type MotionSensor, type VehicleDevice } from "../../api";
import { store } from "../../store";

export interface ListMotionSensorItemCellProps {
    readonly motionSensorId: UUID;
    readonly column: IColumn;
}

@observer
export class ListMotionSensorItemCell extends React.Component<ListMotionSensorItemCellProps> {
    constructor(props: ListMotionSensorItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get motionSensor(): MotionSensor | undefined {
        if (this.props.motionSensorId === undefined) {
            return;
        }
        return store.repositoryMotionSensors.byId(this.props.motionSensorId);
    }

    @computed private get vehicleDevice(): VehicleDevice | undefined {
        if (!this.motionSensor?.vehicleDeviceId) {
            return;
        }
        return store.repositoryVehicleDevices.byId(this.motionSensor.vehicleDeviceId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        switch (column.key) {
            case "vehicleDeviceSerialNumber":
                return <span>{this.vehicleDevice?.serialNumber}</span>;
            case "firmwareLastUpdatedAt":
                return (
                    <span>
                        {this.motionSensor?.firmwareLastUpdatedAt
                            ? store.i18n.formatDateTime(this.motionSensor.firmwareLastUpdatedAt)
                            : ""}
                    </span>
                );
            case "currentFirmwareVersion":
                return <span>{this.motionSensor?.currentVersion}</span>;
            default:
                return <></>;
        }
    }
}
